import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { CrownWrapper, TooltipContent } from './StyledComponents';

/**
 * Season Pass Crown Icon with integrated tooltip
 * Positioned absolutely at top-right of parent container
 * @param {string} tooltipText - The text to display in the tooltip
 */
const SeasonPassIcon = ({ tooltipText = 'Season Pass Holder' }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <CrownWrapper
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 24 24"
        fill="#FA4616"
        stroke="none"
      >
        <path d="M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z" />
      </svg>
      <TooltipContent visible={showTooltip}>{tooltipText}</TooltipContent>
    </CrownWrapper>
  );
};

SeasonPassIcon.propTypes = {
  tooltipText: PropTypes.string,
};

export default SeasonPassIcon;
